import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import { Box, LinearProgress, Stack } from "@mui/material";
import { Theme } from "@mui/material/styles";
import * as React from "react";
import MaterialTable from "../../components/general/material-table";
import { getUniqueTeamMembers } from "../../util/getUniqueTeamMembers";
import { useGetOrgRoles } from "../../tanstackQuery/queries/org-roles";
import { discoverySessionAtom } from "../../stores/jotai/discovery-session";
import { useAtom } from "jotai";
import { useKeycloak } from "@react-keycloak/web";
import { baseAtom } from "../../stores/jotai/base";

interface Props {
  members?: any;
  theme?: Theme;
}

const TeamMembersContainer: React.FC<Props> = (props) => {
  const [discoverySession] = useAtom(discoverySessionAtom);
  const [base] = useAtom(baseAtom);
  const { keycloak } = useKeycloak();
  const [uniqueMembers, setUniqueMembers] = React.useState(undefined);

  const { data: orgRoles, isLoading: isOrgRolesLoading } = useGetOrgRoles(
    { accessToken: keycloak?.token },
    { orgID: base?.team?.orgID, sessionID: discoverySession?.sessionID },
    { enabled: !!(base?.team?.orgID && discoverySession?.sessionID) }
  );

  React.useEffect(() => {
    if (orgRoles) {
      const uniqueMembersData = getUniqueTeamMembers(members, orgRoles);
      setUniqueMembers(uniqueMembersData);
    }
  }, [isOrgRolesLoading, orgRoles]);

  if (isOrgRolesLoading) {
    return <LinearProgress />;
  }

  const renderEmptyMessage = () => {
    const { theme } = props;
    return (
      <Stack
        sx={{
          padding: "40px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <GroupsOutlinedIcon
          sx={{
            fontSize: "150px",
            color: theme?.custom?.disabledColor,
          }}
        />
        <Box>No team member in this team.</Box>
      </Stack>
    );
  };

  const { members } = props;

  const headerStyles = {
    "@media (min-width: 600px)": {
      minHeight: "40px",
    },
    borderRadius: "0px",
  };

  const headCells = [
    {
      id: "avatar",
      align: "left",
      label: "",
    },
    {
      id: "Name",
      align: "left",
      label: "Name",
    },
    {
      id: "Username",
      align: "left",
      label: "Username",
    },
    {
      id: "Roles",
      align: "left",
      label: "Roles",
    },
  ];

  const columnStyles = {
    ".MuiTableCell-root#avatar": { width: "50px" },
    ".MuiTableCell-root#Username": { width: "40%" },
  };

  return uniqueMembers !== undefined &&
    Object?.keys(uniqueMembers)?.length > 0 ? (
    <MaterialTable
      tableName="Team Members"
      tableRows={Object.values(uniqueMembers)}
      headCells={headCells}
      uniqueCol={"userID"}
      columnStyles={columnStyles}
      headerStyles={headerStyles}
      disablePagination
      minimal={true}
      onSelectRow={() => {}}
      selectedRow={undefined}
    />
  ) : (
    renderEmptyMessage()
  );
};

export default TeamMembersContainer;
